
import Image from '@components/Image';

import Link from 'next/link';

import { WagtailImage, WagtailPage } from '@/types';

type LinkTile = {
  title: string;
  button_page: WagtailPage | null;
  button_url: string | null;
  image: WagtailImage | null;
};

type Props = {
  link_kacheln: LinkTile[];
};

function Links(props: Props) {
  const { link_kacheln: linkKacheln } = props;

  return (
    <div className='streamfield links'>
      {linkKacheln.map(tile => (
        <Link
          key={tile.title}
          // href={tile.button_page ? removeBaseUrl(tile.button_page.full_url) : tile.button_url ?? ''}
          href='/'
          className='links__tile'
        >
          <div className='title'>{tile.title}</div>
          {tile.image ? <Image image={tile.image} className='icon' spec='fill-78x78' /> : null}
        </Link>
      ))}
    </div>
  );
}

export default Links;


